import { Injectable } from '@angular/core';
//import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SystemSettingsService {
  logDetail: any;
  LogType: string;
  CompanyLogo: string;
  CompanyRebrand: string;
  UserName: string;//IMP IMP
  isLoggedIn: boolean;
  isCommonLogo: boolean;
  startupScreen: string;
  Criteria: string;
  restrictScreens: string;
  authorizeFilters: string;
  authorizeFilters1: string;
  mainFilterIDs: string;
  ismainFilterEnabled: boolean= true;

  //private appSource = new BehaviorSubject('');
  //appPageRef = this.appSource.asObservable();

  constructor() {
    this.logDetail = "";
    this.LogType  = "";
    this.CompanyLogo  = "";
    this.UserName = "";//IMP IMP
    this.isLoggedIn = false;
    this.isCommonLogo = true;
    this.startupScreen = "";
    this.restrictScreens = "";
    this.Criteria = "";
    this.authorizeFilters = "";
    this.authorizeFilters1 = "";
    this.mainFilterIDs = "";
    this.ismainFilterEnabled = true;
  }

  //pageRefMessage(restrictScreens: any) {
  //  this.appSource.next(restrictScreens);
  //}
}
